export const locale = {
  logout: 'Sign out',
  logout_pending: 'Signing out',
};
